import styled from '@emotion/styled';
import { ButtonBase, type ButtonBaseProps } from '@mui/material';
import stripProps from '@/lib/utils/stripProps';
import addHighContrastStyles from '@/lib/styling/addHighContrastStyles';
import { common } from '@mui/material/colors';

type StyledImagePreviewThumbnailProps = ButtonBaseProps & {
  src: string | null;
  containsInappropriateContent?: boolean;
};

const StyledImagePreviewThumbnail = styled(
  stripProps(ButtonBase, 'src', 'containsInappropriateContent'),
)<StyledImagePreviewThumbnailProps>(
  ({ theme, src, containsInappropriateContent }) => ({
    position: 'relative',
    width: 32,
    height: 32,
    backdropFilter: 'blur(10px)',
    display: src === null && !containsInappropriateContent ? 'none' : undefined,
    borderTopLeftRadius: 4,
    borderBottomLeftRadius: 4,
    overflow: 'hidden',
    '::before': {
      content: '""',
      position: 'absolute',
      top: 0,
      left: 0,
      width: 32,
      height: 32,
      backgroundColor: src !== null ? common.white : undefined,
      backgroundImage: src !== null ? `url('${src}')` : undefined,
      backgroundPosition: 'center',
      backgroundSize: 'cover',
      backgroundRepeat: 'no-repeat',
      filter: containsInappropriateContent ? 'blur(2px)' : undefined,
    },
    '::after': {
      content: '""',
      position: 'absolute',
      top: 0,
      left: 0,
      width: 32,
      height: 32,
      backgroundColor: containsInappropriateContent
        ? 'rgba(0, 0, 0, 0.2)'
        : theme.palette.action.selected,
      opacity: 1,
      transition: theme.transitions.create('opacity'),
    },
    ':hover::after': {
      opacity: src !== null ? 0 : undefined,
    },
    '.MuiSvgIcon-root': {
      width: 16,
      height: 16,
      color: 'rgba(255, 255, 255, 0.6)',
      display: containsInappropriateContent ? undefined : 'none',
      zIndex: 1,
    },
  }),
  addHighContrastStyles(({ theme, containsInappropriateContent }) => ({
    borderRight: `2px solid ${theme.palette.divider}`,
    '::before': {
      content: containsInappropriateContent ? 'none' : undefined,
    },
    '.MuiSvgIcon-root': {
      color: theme.palette.divider,
    },
  })),
);

export default StyledImagePreviewThumbnail;
